import {AiFillCar} from "react-icons/ai";
import './AccountSubscriptions.scss'
import {Badge, Button} from "react-bootstrap";
import {FaMotorcycle} from "react-icons/fa";
import {GiScooter} from "react-icons/gi";
import {useContext} from "react";
import AppContext from "../AppContext";
import {useTranslation} from "react-i18next";
import {Trans} from "react-i18next/icu.macro";

export default function AccountSubscriptions() {

    const { t, i18n } = useTranslation();
    const app = useContext(AppContext)
    const subs = app.user.subscriptions;

    return <>
        <div className="subscription-boxes">
            <div className="subscription-box">
                <div className="title">
                    <AiFillCar /><span>{t('courses.bth')}</span>
                </div>
                <div className="details">
                    <h5 className="mb-3">{subs?.bth?.active > 0 ? <Badge bg="info">{t('active')}</Badge> : <Badge bg="danger">{t('inactive')}</Badge>}</h5>
                    {subs?.bth?.promo_active ? <span>{t('dashboard.orders.promoDays')}</span> :
                        subs?.bth?.active > 0 ? <span><Trans i18nKey="orders.activeDays" count={subs.bth.active} /></span> :
                            <span>{t('orders.expired')}</span>}
                    {subs?.bth?.pending > 0 && !subs?.bth?.promo_active ?
                        <div className="text-muted mt-2"><Trans i18nKey="orders.pendingDays" count={subs.bth.pending} /></div> : <></>}
                </div>
                {!subs?.bth?.promo_active ?
                <div className="actions">
                    {subs.bth.pending <= 0 ?
                        <Button variant="success" href="/pricing/1">{t('button.extend')}</Button>
                        : <Button variant="success"  href="/account#orders">{t('orders.activate')}</Button>}
                </div> : null }
            </div>
            {app.user?.multilingual != 1 &&
            <><div className="subscription-box">
                <div className="title">
                    <FaMotorcycle /><span>{t('courses.ath')}</span>
                </div>
                <div className="details">
                    <h5 className="mb-3">{subs?.ath?.active > 0 ? <Badge bg="info">{t('active')}</Badge> : <Badge bg="danger">{t('inactive')}</Badge>}</h5>
                    {subs?.ath?.promo_active ? <span>{t('dashboard.orders.promoDays')}</span> : subs?.ath?.active > 0 ? <span><Trans i18nKey="orders.activeDays" count={subs.ath.active} /></span> :
                        <span>{t('orders.expired')}</span>}
                    {subs?.ath?.pending > 0 && !subs?.ath?.promo_active ?
                        <div className="text-muted mt-2"><Trans i18nKey="orders.pendingDays" count={subs.ath.pending} /></div> : <></>}
                </div>
                {!subs?.ath?.promo_active ?
                <div className="actions">
                    {subs.ath.pending <= 0 ?
                        <Button variant="success" href="/pricing/1">{t('button.extend')}</Button>
                        : <Button variant="success"  href="/account#orders">{t('orders.activate')}</Button>}
                </div> : null }
            </div>
            <div className="subscription-box">
                <div className="title">
                    <GiScooter /><span>{t('courses.amth')}</span>
                </div>
                <div className="details">
                    <h5 className="mb-3">{subs?.amth?.active > 0 ? <Badge bg="info">{t('active')}</Badge> : <Badge bg="danger">{t('inactive')}</Badge>}</h5>
                    {subs?.amth?.promo_active ? <span>{t('dashboard.orders.promoDays')}</span> : subs?.amth?.active > 0 ? <span><Trans i18nKey="orders.activeDays" count={subs.amth.active} /></span> :
                        <span>{t('orders.expired')}</span>}
                    {subs?.amth?.pending > 0 && !subs?.amth?.promo_active ?
                        <div className="text-muted mt-2"><Trans i18nKey="orders.pendingDays" count={subs.amth.pending} /></div> : <></>}
                </div>
                {!subs?.amth?.promo_active ?
                <div className="actions">
                    {subs.amth.pending <= 0 ?
                        <Button variant="success" href="/pricing/1">{t('button.extend')}</Button>
                        : <Button variant="success"  href="/account#orders">{t('orders.activate')}</Button>}
                </div> : null }
            </div></>}
        </div>
    </>
}